import Lottie from "lottie-react";

function JsonAnimation({ animationData, loop, height, width }) {
  return (
    <Lottie
      animationData={animationData}
      loop={loop}
      style={{ height, width }}
    />
  );
}

export default JsonAnimation;
